import { createAction, props } from '@ngrx/store';

import { PasswordResetData } from '../../api/models/reset-pswd';
import { MfaSetup } from '../../api/models/mfa-setup';

export const AuthLoginEntered = createAction(
    '[AUTH-LOGIN] Auth Login Entered',
    props<{ email: string, firstName: string, lastName: string }>()
);

export const AuthLoginProfile = createAction(
    '[AUTH-LOGIN] Auth Login Profile'
);

export const AuthLogging = createAction(
    '[AUTH-LOGIN] Logging...',
    props<{ isLogging: boolean }>()
);

export const AuthReturnUrlSaved = createAction(
    '[AUTH-LOGIN] Auth Return Url Saved',
    props<{ returnUrl: string }>()
);

export const AuthLoggedIn = createAction(
    '[AUTH-LOGIN] Logged in'
);

export const AuthLogout = createAction(
    '[AUTH-LOGIN] Logout'
);

export const AuthPasswordForgotten = createAction(
    '[AUTH-LOGIN] Forgotten password'
);

export const AuthPasswordResetSendingLink = createAction(
    '[AUTH-LOGIN] Reset Password Sending link',
    props<{ email: string }>()
);

export const AuthPasswordResetLinkSent = createAction(
    '[AUTH-LOGIN] Reset Password Link Sent'
);

// export const AuthRenewPasswordVerify = createAction(
//     '[AUTH-LOGIN] Renew Password Verify',
//     props<{ token: string }>()
// );

export const AuthPasswordReset = createAction(
    '[AUTH-LOGIN] Reset Password',
    props<{ passwordResetData: PasswordResetData }>()
);

export const AuthPasswordResetSucceeded = createAction(
    '[AUTH-LOGIN] Reset Password Succeeded'
);

export const AuthPasswordResetFailed = createAction(
    '[AUTH-LOGIN] Reset Password Failed'
);

export const AuthProblemArisen = createAction(
    '[AUTH-LOGIN] Problem Arisen',
    props<{ error: any }>()
);

export const AuthTwoFactorSetupRequested = createAction(
    '[AUTH-LOGIN] Auth Two Factor Setup Requested',
    props<{ idToken: string }>()
);
export const AuthTwoFactorSetupSucceeded = createAction(
    '[AUTH-LOGIN] Auth Two Factor Setup Succeeded',
    props<{ idToken: string, mfaSetup: MfaSetup }>()
);
export const AuthTwoFactorSetupFailed = createAction(
    '[AUTH-LOGIN] Auth Two Factor Setup Failed',
);

export const AuthTwoFactorSetupVerifyRequested = createAction(
    '[AUTH-LOGIN] Auth Two Factor Setup Verify Requested',
    props<{ idToken: string, verifyCode: string }>()
);
export const AuthTwoFactorSetupVerifySucceeded = createAction(
    '[AUTH-LOGIN] Auth Two Factor Setup Verify Succeeded',
    props<{ idToken: string, verifyCode: string }>()
);
export const AuthTwoFactorSetupVerifyFailed = createAction(
    '[AUTH-LOGIN] Auth Two Factor Setup Verify Failed'
);

export const AuthTwoFactorRequested = createAction(
    '[AUTH-LOGIN] Auth Two Factor Requested',
    props<{ idToken: string; twoFactorMailRequired: boolean; twoFactorRequired: boolean }>()
);

export const AuthTwoFactorLoginRequested = createAction(
    '[AUTH-LOGIN] Auth Two Factor Login Requested',
    props<{ idToken: string, code: string }>()
);

export const AuthTwoFactorLoginFailed = createAction(
    '[AUTH-LOGIN] Auth Two Factor Login Failed'
);
